import { queryOptions } from '@tanstack/react-query';
import { maxDomainsQueryOptions } from '#api/domains.queries.ts';
import type { DomainListItem } from '#dn-types/domain.ts';

export const NO_DOMAIN_FLAG = 'none';
export const NEW_DOMAIN_FLAG = 'new';

const NO_DOMAIN_OPTION = {
  value: NO_DOMAIN_FLAG,
  label: 'Assign later',
} as const;

const NEW_DOMAIN_OPTION = {
  value: NEW_DOMAIN_FLAG,
  label: 'Add new domain',
} as const;

export function makeSelectDomainQueryOptions(filterDomains: (domain: DomainListItem) => boolean = () => true) {
  return queryOptions({
    ...maxDomainsQueryOptions,
    select: (data) => {
      const domainItems = data.data
        .filter((element) => filterDomains(element))
        .map((domain) => ({
          value: domain.id,
          label: domain.domainName,
          hint: domain.isVerified ? 'Verified' : 'Unverified',
        }));

      return {
        items: [...domainItems, NO_DOMAIN_OPTION, NEW_DOMAIN_OPTION],
      };
    },
  });
}
